import React, { useState } from "react";
import "../../styles/input-auto.css";

function TextAuto({ field, pholder, data, onSelected, onChange, className, minStart, maxResults = 25, value }) {
  const [suggestions, setSugesstions] = useState([]);
  const [isHideSuggs, setIsHideSuggs] = useState(false);

  const handler = e => {
    if (e.target.value.length >= minStart) {
      const val = e.target.value.toUpperCase();
      var all_items = data?.filter(i => i[field]?.toUpperCase().startsWith(val));
      setSugesstions(all_items?.slice(0, maxResults));
    }
  };

  const handleChange = e => {
    const input = e.target.value;
    setIsHideSuggs(false);
    onChange(input);
  };

  const hideSuggs = v => {
    onChange(v[field]);
    onSelected(v);
    setIsHideSuggs(true);
  };

  const focusLeft = () => {
    setTimeout(() => {
      setIsHideSuggs(true);
    }, 400);
  };

  return (
    <div className="sugesstion-auto">
      <div>
        {/* Changed from <input> to <textarea> */}
        <textarea
          className={className}
          placeholder={pholder}
          value={value}
          rows="2" 
          onChange={handleChange}
          onKeyUp={handler}
          onBlur={focusLeft}
          style={{ resize: "vertical" }} // Allows user to pull it down if needed
        />
      </div>
      <div className="suggestions" style={{ display: isHideSuggs ? "none" : "block" }}>
        {suggestions?.map((item, idx) => (
          <div
            key={"" + item[field] + idx}
            onClick={() => hideSuggs(item)}
          >
            {item[field]}
          </div>
        ))}
      </div>
    </div>
  );
}

export default TextAuto;